import React, { Component } from 'react';
import { Route, Switch as Routes } from 'react-router-dom';
import Login from '../login/Login';

const RouterExternal = () => {
  return (
    <Routes>
      <Route exact path="/" children={<Login />} />
      <Route exact path="/login" children={<Login />} />
      <Route children={<Login />} />
    </Routes>
  );
}

export default RouterExternal;
